import type { AxiosPromise } from "axios";

import type { Request, Response } from "./types";

import { http } from ".";

export const Login = (data: Request.Login): AxiosPromise<Response.Login> => http.post("/auth/login", data);

export const Register = (data: Request.Register): AxiosPromise<void> => http.post("/auth/register", data);

export const CurrentUser = (): AxiosPromise<Response.CurrentUser> => http.get("/users/current-user");

export const UpdateUser = (data: Request.UpdateUser): AxiosPromise<void> => http.patch("/users/update-user", data, { headers: { "Content-Type": "multipart/form-data" } });

export const JobsList = (data: Request.JobsList): AxiosPromise<Response.JobsList> => http.get("/jobs", { params: data });

export const AddJob = (data: Request.AddJob): AxiosPromise<Response.AddJob> => http.post("/jobs", data);

export const ApplicationStats = (): AxiosPromise<Response.ApplicationStats> => http.get("/users/admin/statistics");

export const SingleJob = (id: string): AxiosPromise<Response.SingleJob> => http.get(`/jobs/${id}`);

export const DeleteJob = (id: string): AxiosPromise<void> => http.delete(`/jobs/${id}`);

export const EditJob = (id: string, data: Request.EditJob): AxiosPromise<Response.EditJob> => http.patch(`/jobs/${id}`, data);

export const ShowStats = (): AxiosPromise<Response.ShowStats> => http.get("/jobs/data/stats");
